/* =========================================================
   SHOPIFY — PRODUCT INFO
   Código original + BAMBÚ HOME DESCRIPTION
   ========================================================= */

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {

      constructor() {
        super();

        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');

        this.cartUpdateUnsubscriber = undefined;
        this.variantChangeUnsubscriber = undefined;
      }


      /* =====================================================
         CONECTAR COMPONENTE
         ===================================================== */

      connectedCallback() {

        /*
         * IMPORTANTE:
         * ProductInfo puede existir aunque no tenga cantidad.
         * No detenemos aquí otros componentes de la página.
         */

        if (!this.input) return;

        this.quantityForm = this.querySelector('.product-form__quantity');

        if (!this.quantityForm) return;

        this.setQuantityBoundries();


        /* ===================================================
           ACTUALIZACIÓN DEL CARRITO
           =================================================== */

        if (!this.dataset.originalSection) {

          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );

        }


        /* ===================================================
           CAMBIO DE VARIANTE
           =================================================== */

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {

            const sectionId =
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section;

            if (event.data.sectionId !== sectionId) return;

            this.updateQuantityRules(
              event.data.sectionId,
              event.data.html
            );

            this.setQuantityBoundries();
          }
        );
      }


      /* =====================================================
         DESCONECTAR
         ===================================================== */

      disconnectedCallback() {

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }


      /* =====================================================
         LÍMITES DE CANTIDAD
         ===================================================== */

      setQuantityBoundries() {

        if (!this.input) return;

        const data = {

          cartQuantity:
            this.input.dataset.cartQuantity
              ? parseInt(this.input.dataset.cartQuantity)
              : 0,

          min:
            this.input.dataset.min
              ? parseInt(this.input.dataset.min)
              : 1,

          max:
            this.input.dataset.max
              ? parseInt(this.input.dataset.max)
              : null,

          step:
            this.input.step
              ? parseInt(this.input.step)
              : 1
        };


        let min = data.min;

        const max =
          data.max === null
            ? data.max
            : data.max - data.cartQuantity;


        if (max !== null) {
          min = Math.min(min, max);
        }


        if (data.cartQuantity >= data.min) {
          min = Math.min(min, data.step);
        }


        this.input.min = min;
        this.input.max = max;
        this.input.value = min;


        if (
          typeof publish === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined'
        ) {

          publish(
            PUB_SUB_EVENTS.quantityUpdate,
            undefined
          );

        }
      }


      /* =====================================================
         OBTENER REGLAS DE CANTIDAD
         ===================================================== */

      fetchQuantityRules() {

        if (
          !this.currentVariant ||
          !this.currentVariant.value
        ) {
          return;
        }


        const spinner =
          this.querySelector(
            '.quantity__rules-cart .loading__spinner'
          );


        if (spinner) {
          spinner.classList.remove('hidden');
        }


        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )

          .then((response) => {
            return response.text();
          })

          .then((responseText) => {

            const html =
              new DOMParser().parseFromString(
                responseText,
                'text/html'
              );


            this.updateQuantityRules(
              this.dataset.section,
              html
            );


            this.setQuantityBoundries();
          })

          .catch((error) => {

            console.error(
              'Bambú Home — Error actualizando cantidad:',
              error
            );

          })

          .finally(() => {

            if (spinner) {
              spinner.classList.add('hidden');
            }

          });
      }


      /* =====================================================
         ACTUALIZAR REGLAS
         ===================================================== */

      updateQuantityRules(sectionId, html) {

        const quantityFormUpdated =
          html.getElementById(
            `Quantity-Form-${sectionId}`
          );


        if (!quantityFormUpdated) {
          return;
        }


        const selectors = [
          '.quantity__input',
          '.quantity__rules',
          '.quantity__label'
        ];


        for (const selector of selectors) {

          const current =
            this.quantityForm.querySelector(selector);

          const updated =
            quantityFormUpdated.querySelector(selector);


          if (!current || !updated) {
            continue;
          }


          /* -----------------------------------------------
             INPUT
             ----------------------------------------------- */

          if (selector === '.quantity__input') {

            const attributes = [
              'data-cart-quantity',
              'data-min',
              'data-max',
              'step'
            ];


            for (const attribute of attributes) {

              const valueUpdated =
                updated.getAttribute(attribute);


              if (valueUpdated !== null) {

                current.setAttribute(
                  attribute,
                  valueUpdated
                );

              }

            }

          }


          /* -----------------------------------------------
             OTROS ELEMENTOS
             ----------------------------------------------- */

          else {

            current.innerHTML =
              updated.innerHTML;

          }

        }
      }
    }
  );
}


/* =========================================================
   BAMBÚ HOME
   DESCRIPCIÓN — MOSTRAR MÁS / MOSTRAR MENOS
   ========================================================= */

(function () {

  'use strict';


  /* =======================================================
     INICIALIZAR DESCRIPCIONES
     ======================================================= */

  function initBambuDescriptions() {

    const descriptions =
      document.querySelectorAll(
        '.bh-description'
      );


    if (!descriptions.length) {
      return;
    }


    descriptions.forEach((description) => {

      /* Evitar inicializar dos veces */
      if (
        description.dataset.bhDescriptionReady === 'true'
      ) {
        return;
      }


      const toggle =
        description.querySelector(
          '.bh-description__toggle'
        );


      const content =
        description.querySelector(
          '.bh-description__content'
        );


      const toggleText =
        description.querySelector(
          '.bh-description__toggle-text'
        );


      const icon =
        description.querySelector(
          '.bh-description__icon'
        );


      /* Si falta algo, no hacemos nada */
      if (!toggle || !content) {
        return;
      }


      description.dataset.bhDescriptionReady = 'true';


      /* ===================================================
         ESTADO INICIAL
         =================================================== */

      description.classList.remove('is-open');

      toggle.setAttribute(
        'aria-expanded',
        'false'
      );


      content.setAttribute(
        'aria-hidden',
        'true'
      );


      /* ===================================================
         TEXTO INICIAL
         =================================================== */

      if (toggleText) {

        toggleText.textContent =
          'Mostrar más';

      }


      /* ===================================================
         ICONO INICIAL
         =================================================== */

      if (icon) {

        icon.setAttribute(
          'aria-hidden',
          'true'
        );

      }


      /* ===================================================
         CLICK
         =================================================== */

      toggle.addEventListener(
        'click',
        function (event) {

          event.preventDefault();


          const isOpen =
            description.classList.contains(
              'is-open'
            );


          /* ===============================================
             ABRIR
             =============================================== */

          if (!isOpen) {

            description.classList.add(
              'is-open'
            );


            toggle.setAttribute(
              'aria-expanded',
              'true'
            );


            content.setAttribute(
              'aria-hidden',
              'false'
            );


            if (toggleText) {

              toggleText.textContent =
                'Mostrar menos';

            }

          }


          /* ===============================================
             CERRAR
             =============================================== */

          else {

            description.classList.remove(
              'is-open'
            );


            toggle.setAttribute(
              'aria-expanded',
              'false'
            );


            content.setAttribute(
              'aria-hidden',
              'true'
            );


            if (toggleText) {

              toggleText.textContent =
                'Mostrar más';

            }

          }

        }
      );

    });

  }


  /* =======================================================
     CARGA NORMAL
     ======================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initBambuDescriptions
    );

  } else {

    initBambuDescriptions();

  }


  /* =======================================================
     SHOPIFY — RECARGA DINÁMICA DE SECCIONES
     
     Esto es IMPORTANTE porque Shopify puede volver a
     renderizar Información del producto cuando cambia
     una variante.
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function () {

      initBambuDescriptions();

    }
  );


  /* =======================================================
     OBSERVER
     
     Detecta cuando Shopify vuelve a insertar la descripción.
     ======================================================= */

  const observer =
    new MutationObserver(
      function (mutations) {

        let shouldInitialize = false;


        mutations.forEach(
          function (mutation) {

            if (
              mutation.addedNodes &&
              mutation.addedNodes.length
            ) {

              shouldInitialize = true;

            }

          }
        );


        if (shouldInitialize) {

          initBambuDescriptions();

        }

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();